import React, { useState } from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { place_order } from "../store/reducers/orderReducer";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const Shipping = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const {
    state: { products, price, shipping_fee, items },
  } = useLocation();
  const [res, setRes] = useState(false);
  const [state, setState] = useState({
    name: "",
    address: "",
    phone: "",
    post: "",
    province: "",
    city: "",
    area: "",
  });
  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const save = (e) => {
    e.preventDefault();
    const { name, address, phone, post, province, city, area } = state;
    if (name && address && phone && post && province && city && area) {
      setRes(true);
    }
  };
  const placeOrder = () => {
    if (!selectedPayment) return alert("Select Payment Method");
    dispatch(
      place_order({
        price,
        products,
        shipping_fee,
        shippingInfo: state,
        userId: userInfo.id,
        navigate,
        items,
        selectedPayment,
      })
    );
  };

  const handleBackButtonClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const handlePaymentSelect = (method) => {
    setSelectedPayment(method);
  };

  return (
    <div>
      <div className="block">
        <Headers />
      </div>

      {/* <div className="hidden xs:flex items-center justify-between px-4 py-3 bg-white rounded-b-xl shadow-sm">
                <div
                    onClick={handleBackButtonClick}
                    className="border-2 border-[#dbdbdb] rounded-[10px] p-1"
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 11 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M9.09595 15.017C9.32528 15.018 9.54923 14.95 9.73666 14.8223C9.92409 14.6945 10.0657 14.5134 10.1418 14.3043C10.2178 14.0951 10.2246 13.8682 10.1611 13.6551C10.0977 13.442 9.96712 13.2534 9.78763 13.1153L2.93516 7.63641L9.58381 1.93383C9.70461 1.84481 9.80509 1.73268 9.87896 1.60436C9.95283 1.47604 9.9985 1.3343 10.0131 1.18811C10.0277 1.04191 10.0109 0.894396 9.96384 0.754738C9.91674 0.615081 9.84032 0.486279 9.73939 0.376479C9.63845 0.266681 9.51516 0.178308 9.37724 0.116702C9.23931 0.0550958 9.08973 0.0216995 8.93786 0.0185744C8.78598 0.0154493 8.63508 0.042595 8.49462 0.0984715C8.35415 0.154349 8.22714 0.237669 8.12153 0.343218L0.509323 6.86629C0.389777 6.96847 0.294582 7.0944 0.230306 7.23561C0.16603 7.37682 0.134202 7.52988 0.137015 7.68416C0.139827 7.83844 0.177213 7.99034 0.246597 8.12932C0.31598 8.2683 0.415709 8.3911 0.538906 8.48922L8.38432 14.7601C8.58262 14.9245 8.83478 15.0156 9.09595 15.0172L9.09595 15.017Z"
                            fill="#464646"
                        />
                    </svg>
                </div>
                <p className="text-base font-semibold text-[#212B36]">{res ? "Payment" : "Address"}</p>
                <div></div>
            </div> */}

      <section
        className=" h-[220px] md:hidden bg-cover bg-no-repeat relative bg-left"
        style={{ backgroundImage: `url(/images/banner/order.jpg)` }}
      >
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">Ariz Supermart</h2>
              <div className="flex justify-center items-center gap-2 text-2xl w-full">
                <Link to="/">Home</Link>
                <span className="pt-2">
                  <MdOutlineKeyboardArrowRight />
                </span>
                <span>Place Order</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[whitesmoke]">
        <div className="w-[85%] lg:w-[90%] md:w-[90%] mx-auto py-16">
          <div className="w-full flex flex-wrap">
            <div className="w-[67%] md-lg:w-full">
              <div className="flex flex-col gap-3">
                <div className="bg-white p-6 drop-shadow-md rounded-lg">
                  {!res && (
                    <>
                      <h2 className="block text-slate-600 font-bold pb-3">
                        Shipping Information
                      </h2>
                      <form onSubmit={save} className="">
                        <div>
                          <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="name" className="block">
                                Name
                              </label>
                              <input
                                onChange={inputHandle}
                                value={state.name}
                                type="text"
                                className="w-full px-3 py-2 border border-primaryLighter outline-none focus:border-primaryLight rounded-lg input-placeholder"
                                name="name"
                                placeholder="Name"
                                id="name"
                                required
                              />
                            </div>
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="address" className="block">
                                Address
                              </label>
                              <input
                                onChange={inputHandle}
                                value={state.address}
                                type="text"
                                className="w-full px-3 py-2 border border-primaryLighter outline-none focus:border-primaryLight rounded-lg input-placeholder"
                                name="address"
                                placeholder="House no / building / strreet /area"
                                id="address"
                                required
                              />
                            </div>
                          </div>
                          <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="phone" className="block ">
                                Phone
                              </label>
                              <input
                                onChange={inputHandle}
                                value={state.phone}
                                type="text"
                                className="w-full px-3 py-2 border border-primaryLighter outline-none focus:border-primaryLight rounded-lg input-placeholder"
                                name="phone"
                                placeholder="+92XXXXXXXXXX"
                                id="phone"
                                required
                              />
                            </div>
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="post" className="block">
                                Post
                              </label>
                              <input
                                onChange={inputHandle}
                                value={state.post}
                                type="text"
                                className="w-full px-3 py-2 border border-primaryLighter outline-none focus:border-primaryLight rounded-lg input-placeholder"
                                name="post"
                                placeholder="Postal Code"
                                id="post"
                                required
                              />
                            </div>
                          </div>
                          <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="province" className="block">
                                Province
                              </label>
                              <input
                                onChange={inputHandle}
                                value={state.province}
                                type="text"
                                className="w-full px-3 py-2 border border-primaryLighter outline-none focus:border-primaryLight rounded-lg input-placeholder"
                                name="province"
                                placeholder="Province"
                                id="province"
                                required
                              />
                            </div>
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="city" className="block">
                                City
                              </label>
                              <input
                                onChange={inputHandle}
                                value={state.city}
                                type="text"
                                className="w-full px-3 py-2 border border-primaryLighter outline-none focus:border-primaryLight rounded-lg input-placeholder"
                                name="city"
                                placeholder="City"
                                id="city"
                                required
                              />
                            </div>
                          </div>
                          <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="area" className="block">
                                Area
                              </label>
                              <input
                                onChange={inputHandle}
                                value={state.area}
                                type="text"
                                className="w-full px-3 py-2 border border-primaryLighter outline-none focus:border-primaryLight rounded-lg input-placeholder"
                                name="area"
                                placeholder="Area"
                                id="area"
                                required
                              />
                            </div>
                            <div className=" flex flex-col gap-1 mt-3 w-full">
                              <button className="px-3 py-[6px] rounded-lg hover:shadow-secondary/20 hover:shadow-lg bg-secondary text-white">
                                Save
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="flex flex-col gap-1 w-full">
                          <button className="hidden mt-3 text-sm py-2 font-normal rounded-full px-5 hover:shadow-blue-700/20 hover:shadow-lg bg-secondary text-md text-white ">
                            Confirm Address
                          </button>
                        </div>
                      </form>
                    </>
                  )}
                  {res && (
                    <>
                      <div className="flex flex-col gap-1">
                        <h2 className="text-slate-600 font-semibold pb-2">
                          Deliver to {state.name}
                        </h2>
                        <p className="flex items-center">
                          <span className="bg-blue-200 text-blue-800 items-center md:items-center font-medium mr-2 px-2 py-0.5 md:px-2 md:py-0 md:mr-1 rounded">
                            Address
                          </span>
                          <span className="text-slate-600 text-md ">
                            {state.address} {state.province} {state.city}{" "}
                            {state.area}
                          </span>
                        </p>
                        {/* <span
                                                    onClick={() => setRes(false)}
                                                    className="block xs:hidden text-red-700 right-0 cursor-pointer"
                                                >
                                                    {" "}
                                                    change
                                                </span> */}

                        <p className="flex items-center mt-1">
                          <span className="bg-blue-200 text-blue-800 items-center md:items-center font-medium mr-2 px-2 py-0.5 md:px-2 md:py-0 md:mr-1 rounded">
                            Email
                          </span>
                          <span className="text-slate-600 text-md ml-5">
                            {userInfo.email}
                          </span>
                        </p>

                        <div
                          onClick={() => setRes(false)}
                          className="absolute right-[-5px] top-0 border-2 bg-primaryLighter border-purple-300 rounded-[10px] p-1"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z"
                              stroke="#000000"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13"
                              stroke="#000000"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </div>

                      <div className="w-full max-w-md mt-5">
                        {/* Visa Card */}
                        <div
                          onClick={() => handlePaymentSelect("visa")}
                          className={`flex items-center justify-between bg-white shadow-sm border p-3 rounded-lg cursor-pointer mb-4 ${
                            selectedPayment === "visa"
                              ? "border-primaryLight"
                              : "border-primaryLighter"
                          }`}
                        >
                          <div className="flex items-center gap-2">
                            <div className="p-2 rounded-full bg-slate-200">
                              <svg
                                width="26"
                                height="26"
                                viewBox="0 0 30 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <ellipse
                                  opacity="0.8"
                                  cx="8.27298"
                                  cy="8.92929"
                                  rx="8.14798"
                                  ry="8.92929"
                                  fill="#F14336"
                                />
                                <ellipse
                                  cx="20.9561"
                                  cy="8.92929"
                                  rx="8.14798"
                                  ry="8.92929"
                                  fill="#FFC107"
                                />
                                <ellipse
                                  opacity="0.5"
                                  cx="8.27298"
                                  cy="8.92941"
                                  rx="8.14798"
                                  ry="8.92929"
                                  fill="#F14336"
                                />
                              </svg>
                            </div>
                            <div>
                              <p className="text-sm font-semibold">
                                Card Payment
                              </p>
                              <p className="text-gray-500 text-xs">
                                Continue with Card
                              </p>
                            </div>
                          </div>
                          <div>
                            <span className="text-xl text-primaryLight">
                              {selectedPayment === "visa" ? "✓" : "→"}
                            </span>
                          </div>
                        </div>

                        {/* Cash on Delivery */}
                        <div
                          onClick={() => handlePaymentSelect("cod")}
                          className={`flex items-center justify-between border p-3 bg-white shadow-sm rounded-lg cursor-pointer ${
                            selectedPayment === "cod"
                              ? "border-primaryLight"
                              : "border-primaryLighter"
                          }`}
                        >
                          <div className="flex items-center gap-2">
                            <div className="p-2 rounded-full bg-slate-200">
                              <svg
                                width="25"
                                height="27"
                                viewBox="0 0 30 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_93_753)">
                                  <path
                                    d="M12.6339 30.8697L3.42577 22.9919C2.98935 22.6186 2.9128 21.9282 3.25474 21.4504L18.3063 0.421306C18.6478 -0.0557968 19.2775 -0.140272 19.7133 0.232525L28.9215 8.11026C29.3579 8.48357 29.4344 9.17398 29.0925 9.65179L14.0409 30.6809C13.6994 31.158 13.0698 31.2425 12.6339 30.8697Z"
                                    fill="#57AD7B"
                                  />
                                  <path
                                    d="M6.82075 31.514L0.315382 20.8907C0.00693108 20.387 0.130194 19.7045 0.590579 19.3667L20.8681 4.48899C21.3279 4.15161 21.9501 4.28585 22.2582 4.78897L28.7636 15.4123C29.072 15.916 28.9488 16.5984 28.4884 16.9363L8.2109 31.814C7.75104 32.1514 7.12885 32.0171 6.82075 31.514Z"
                                    fill="#81CDA1"
                                  />
                                  <path
                                    d="M28.7626 15.4123L22.2573 4.78897C21.9492 4.28585 21.327 4.15161 20.8672 4.48899L20.078 5.06795L26.4126 15.4123C26.721 15.916 26.5978 16.5984 26.1374 16.9363L6.64893 31.235L6.81978 31.514C7.12788 32.0171 7.75007 32.1514 8.20992 31.814L28.4874 16.9363C28.9479 16.5984 29.0711 15.916 28.7626 15.4123Z"
                                    fill="#60BF88"
                                  />
                                  <path
                                    d="M19.8743 18.501C20.0455 15.274 17.7944 12.5059 14.8465 12.3181C11.8986 12.1304 9.37014 14.5941 9.19901 17.8211C9.02789 21.048 11.2789 23.8161 14.2268 24.0039C17.1747 24.1916 19.7032 21.7279 19.8743 18.501Z"
                                    fill="#29795D"
                                  />
                                  <path
                                    d="M3.36496 17.3306C4.70105 19.5124 4.16852 22.4667 2.17551 23.9289L0.313998 20.8891C0.00595838 20.3861 0.129515 19.7044 0.590017 19.3666L3.36496 17.3306Z"
                                    fill="#29795D"
                                  />
                                  <path
                                    d="M4.96387 28.4825C6.9611 27.0171 9.66107 27.5941 10.9943 29.7714L8.21171 31.813C7.75126 32.1509 7.12825 32.0169 6.82021 31.514L4.96387 28.4825Z"
                                    fill="#29795D"
                                  />
                                  <path
                                    d="M25.7139 18.9742C24.3778 16.7924 24.9103 13.8381 26.9033 12.3759L28.7648 15.4157C29.0729 15.9187 28.9493 16.6004 28.4888 16.9382L25.7139 18.9742Z"
                                    fill="#29795D"
                                  />
                                  <path
                                    d="M24.1154 7.82258C22.1182 9.28802 19.4182 8.71092 18.085 6.53363L20.8676 4.492C21.328 4.15417 21.9511 4.28809 22.2591 4.79108L24.1154 7.82258Z"
                                    fill="#29795D"
                                  />
                                  <path
                                    d="M21.2497 13.7109C21.1075 13.7109 20.9681 13.6357 20.8831 13.4966C20.7477 13.2749 20.8019 12.975 21.0041 12.8266L23.0785 11.3047C23.2807 11.1564 23.5545 11.2157 23.6898 11.4373C23.8252 11.6589 23.771 11.9588 23.5688 12.1072L21.4944 13.6292C21.4192 13.6844 21.3339 13.7109 21.2497 13.7109Z"
                                    fill="#29795D"
                                  />
                                  <path
                                    d="M5.75455 25.0798C5.61243 25.0798 5.47301 25.0046 5.38799 24.8654C5.25263 24.6438 5.3068 24.3439 5.50902 24.1956L7.58334 22.6736C7.78551 22.5252 8.05918 22.5846 8.19466 22.8062C8.33003 23.0279 8.27586 23.3278 8.07363 23.4761L5.99931 24.9981C5.92399 25.0533 5.8388 25.0798 5.75455 25.0798Z"
                                    fill="#29795D"
                                  />
                                  <path
                                    d="M16.5983 20.7182C17.2336 20.0006 17.2543 19.0078 16.9652 18.3056C16.5877 17.3887 15.7556 16.9616 14.845 17.2176C14.7355 17.2484 14.6233 17.279 14.5102 17.3082L13.5105 15.6757C13.7616 15.5864 13.9573 15.6097 13.9767 15.6123C14.216 15.6501 14.4381 15.47 14.4749 15.208C14.5121 14.9444 14.3472 14.6978 14.1067 14.657C14.0762 14.6519 13.5766 14.5742 13.0081 14.8554L12.8143 14.5388C12.6786 14.3174 12.405 14.2583 12.2028 14.4069C12.0008 14.5556 11.9469 14.8555 12.0825 15.077L12.2939 15.4224C12.2594 15.4629 12.2251 15.5049 12.1914 15.5497C11.8031 16.0666 11.7179 16.7878 11.9693 17.4318C12.1991 18.0206 12.6619 18.4122 13.1771 18.4538C13.4385 18.4748 13.7331 18.454 14.1077 18.3842L15.3941 20.485C15.1392 20.6367 14.9341 20.684 14.5491 20.6891C14.3058 20.6923 14.1109 20.9111 14.1139 21.1778C14.1167 21.4424 14.3134 21.6549 14.5543 21.6549H14.5598C15.1602 21.6469 15.507 21.5296 15.8866 21.2893L16.1038 21.644C16.1888 21.7829 16.3281 21.8579 16.4701 21.8579C16.5545 21.8579 16.6399 21.8313 16.7153 21.7759C16.9173 21.6273 16.9712 21.3273 16.8356 21.1058L16.5983 20.7182ZM13.242 17.4907C13.0594 17.4759 12.8779 17.3038 12.7797 17.052C12.6953 16.8361 12.666 16.5277 12.8088 16.2629L13.5587 17.4874C13.4457 17.4965 13.3389 17.4985 13.242 17.4907ZM15.064 18.1531C15.7893 17.9494 16.0877 18.5224 16.162 18.7029C16.3014 19.0414 16.3118 19.5009 16.0845 19.879L15.0329 18.1618C15.0434 18.1588 15.0533 18.1561 15.064 18.1531Z"
                                    fill="#81CDA1"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_93_753">
                                    <rect
                                      width="29.2"
                                      height="32"
                                      fill="white"
                                      transform="translate(0.125 0.00012207)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <div>
                              <p className="text-sm font-semibold">
                                Cash On Delivery
                              </p>
                              <p className="text-gray-500 text-xs">
                                Continue with this method
                              </p>
                            </div>
                          </div>
                          <div>
                            <span className="text-xl text-primaryLight">
                              {selectedPayment === "cod" ? "✓" : "→"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* DESKTOP */}
            <div className="block w-[33%] md-lg:w-full md:pt-2 md:pb-[20%]">
              <div className="pl-3 md-lg:pl-0 ">
                <div className="bg-white drop-shadow-md rounded-lg font-medium p-5 text-slate-600 flex flex-col gap-3">
                  <h2 className="block text-xl text-[#212730] font-semibold">
                    Order Summary
                  </h2>
                  <div className="flex justify-between items-center">
                    <span>Total Items</span>
                    <span>{items}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span>Delivery Fee</span>
                    <span>Rs.{shipping_fee}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span>Total Payment</span>
                    <span>Rs.{price}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span>Payment Method:</span>
                    <span>
                      {selectedPayment === "visa"
                        ? "Card"
                        : selectedPayment === "cod"
                        ? "Cod"
                        : "None"}
                    </span>
                  </div>
                  <div className="w-[90] h-[2px] bg-[#212730] mt-3"></div>
                  <div className="flex justify-between font-semibold items-center">
                    <span>Total</span>
                    <span>Rs.{price + shipping_fee}</span>
                  </div>
                  <button
                    onClick={placeOrder}
                    disabled={res ? false : true}
                    className={`px-5 flex justify-center items-center py-[6px] rounded-lg ${
                      res
                        ? "bg-secondary hover:shadow-[#212730]/20 hover:shadow-lg"
                        : "bg-slate-300 cursor-not-allowed"
                    } text-sm text-white uppercase`}
                  >
                    Place Order
                  </button>
                </div>
              </div>
            </div>

            {/* MOBILE */}
            {res && (
              <div className="hidden w-full py-8">
                <div className="font-medium p-0 text-slate-800 flex flex-col gap-2">
                  <div className="flex justify-between items-center">
                    <span className="xs:text-sm font-semibold">
                      Total Items
                    </span>
                    <span className="xs:text-sm xs:text-slate-700">
                      {items}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="xs:text-sm font-semibold">
                      Delivery Fee
                    </span>
                    <span className="xs:text-sm xs:text-slate-700">
                      Rs.{shipping_fee}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="xs:text-sm font-semibold">
                      Total Payment
                    </span>
                    <span className="xs:text-sm xs:text-slate-700">
                      Rs.{price}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="xs:text-sm font-semibold">
                      Payment Method:
                    </span>
                    <span className="xs:text-sm xs:text-slate-700">
                      {selectedPayment === "visa"
                        ? "Card"
                        : selectedPayment === "cod"
                        ? "Cod"
                        : "NA"}
                    </span>
                  </div>
                  <div className="h-[1px] bg-primary mt-3"></div>
                  <div className="flex justify-between font-semibold items-center">
                    <span className="xs:text-sm font-semibold">Total</span>
                    <span className="xs:text-sm xs:text-slate-700">
                      Rs.{price + shipping_fee}
                    </span>
                  </div>
                  <button
                    onClick={placeOrder}
                    disabled={!res}
                    className={`px-5 flex justify-center items-center py-[6px] rounded-full ${
                      res
                        ? "bg-[#212730] hover:shadow-[#212730]/20 hover:shadow-lg"
                        : "bg-gray-400 cursor-not-allowed"
                    } text-sm text-white mt-3`}
                  >
                    Place Order
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Shipping;
